<div class="timeout-editor">
  <input type="number" min="1" step="1" [(ngModel)]="value" name="timeoutValue" required [disabled]="disabled" (ngModelChange)="update()" aria-label="Timeout value">
  <select [(ngModel)]="unit" name="timeoutUnit" [disabled]="disabled" (ngModelChange)="update()" aria-label="Timeout unit">
    <option value="minutes">Minutes</option>
    <option value="hours">Hours</option>
  </select>
</div>
